// extracted by mini-css-extract-plugin
export default {"link":"Phone_link__ODuaa","myAnimation":"Phone_myAnimation__Jl86d","icon":"Phone_icon__lVrlo"};